module.exports = __webpack_public_path__ + "static/media/seller.e14d974b.svg";